export default {
  general: {
    messages: {
      success: {
        title: 'Success',
        message: 'Your changes have been saved!',
      },
      error: {
        title: 'Error',
        message: 'Please enter in all required fields!',
      },
    },
    buttons: {
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
    },
  },
  messages: {
    requestError: 'Something went wrong. Please try again later',
    exception: 'Something went wrong. Please try again later',
  },
  buttons: {
    save: 'Save',
    submit: 'Submit',
    invite: 'Invite',
    start: 'Start',
    acceptInvitation: 'Accept Invitation',
    resendInvitation: 'Resend Invitation',
    removeMembership: 'Remove Membership',
  },
  form: {
    validations: {
      required: 'This field is required.',
      email: 'Please provide a valid email address.',
    },
    messages: {
      notValid: 'Please enter in all required fields!',
    },
  },
  pages: {
    about: {
      title: 'About',
    },
    activityLogs: {
      title: 'Activity Logs',
    },
    accountSettings: {
      title: 'Account Settings',
    },
    appsSettings: {
      title: 'Apps Settings',
    },
    companySettings: {
      title: 'Company Settings',
    },
    userAccountProfile: {
      title: 'User Profiles',
    },

    package: {
      title: 'Package Seletion',
    },
    dashboard: {
      title: 'Dashboard',
      buttons: {
        support: 'Contact Support',
      },
      messages: {
        selectApplication: 'Select your application',
      },
    },
    timeclockDashboard: {
      title: 'Timeclock',
    },
    inviteUsers: {
      title: 'Manage Invites',
    },
    invitation: {
      title: 'Accept Invitation',
    },
    users: {
      title: 'Users',
    },
    userCreate: {
      title: 'New User',
    },
    error: {
      title: 'Error',
      messages: {
        text: 'You may have arrived at this page in error or something went terribly wrong. Please contact support.',
      },
      buttons: {
        support: 'Contact Support',
      },
    },
    notAuthorized: {
      title: 'Not authorized',
      messages: {
        text: 'You may have arrived at this page by mistake. Please go back and try again.',
      },
    },
    home: {
      title: 'Home',
      buttons: {
        notRegistered: 'Register',
        support: 'Contact Support',
      },
      catchPhrase: 'Time management doesn’t have to be complicated.',
      supplementaryText: 'For those who are good stewards of time and want a more efficient way to manage it or if you are a business and want a single solution for time management.',
      betaText: 'Currently in beta and not yet open to the public.',
    },
    login: {
      title: 'Login',
      buttons: {
        forgotPassword: 'Forgot password?',
      },
    },
    passwordReset: {
      title: 'Reset Password',
      tokenExpired: 'This reset password token already used. No valid anymore',
      buttons: {
        backToLogin: 'Login',
      },
    },
    registration: {
      title: 'Registration',
      buttons: {
        haveAccount: 'Already have an account?',
      },
    },
    userProfile: {
      title: 'User Profile',
    },
    policy: {
      title: 'Company Policy',
    },
    ptoRequests: {
      title: 'PTO Requests',
    },
    pto: {
      title: 'PTO',
    },
    schedules: {
      title: 'Schedules',
    },
    support: {
      title: 'Contact Support',
    },
    timesheet: {
      title: 'Timesheet',
    },
    timesheets: {
      title: 'Timesheets',
    },
    timesheetsArchive: {
      title: 'Timesheets Archive',
    },
  },
  components: {
    schedule: {
      days: {
        1: 'Sunday',
        2: 'Monday',
        3: 'Tuesday',
        4: 'Wednesday',
        5: 'Thursday',
        6: 'Friday',
        7: 'Saturday',
      },
    },
    login: {
      title: 'Login',
      buttons: {
        forgotPassword: 'Need help signing in?',
      },
    },
  },
  modules: {
    user: {
      messages: {
        loggedIn: 'You have been successfully logged in.',
        registered: 'Confirmation email has been sent to your email.',
        accountUpdated: 'Account has been updated successfully.',
        passwordUpdated: 'Account has been updated successfully. Please login using your new password.',
        passwordResetSent: 'Email has been sent to you. Please check it out',
        confirmed: 'You email address has been confirmed.',
        confirmationError: 'There was a problem.',
      },
      fields: {
        email: {
          label: 'Email',
          placeholder: 'Email',
        },
        password: {
          label: 'Password',
          placeholder: 'Password',
        },
        firstName: {
          label: 'First Name',
          placeholder: 'First Name',
        },
        lastName: {
          label: 'Last Name',
          placeholder: 'Last Name',
        },
        passwordConfirmation: {
          label: 'Confirm',
          placeholder: 'Password',
        },
        locale: {
          label: 'Language',
          placeholder: 'Language',
        },
        timezone: {
          label: 'Timezone',
          placeholder: 'Timezone',
        },
        employmentType: {
          label: 'Employment Type',
          placeholder: 'Employment Type',
        },
        joiningDate: {
          label: 'Joining Date',
          placeholder: 'Joining Date',
        },
        remainingPtoDays: {
          label: 'PTO/Vacation Days',
          placeholder: 'PTO/Vacation Days',
        },
        remainingSicknessDays: {
          label: 'Sickness & Wellness Days',
          placeholder: 'Sickness & Wellness Days',
        },
        admin: {
          label: 'Is this an admin account?',
        },
        master: {
          label: 'Is this a master account?',
        },
      },
    },
    company: {
      messages: {
        updated: 'Company information have been updated successfully.',
      },
      fields: {
        name: {
          label: 'Company name',
          placeholder: 'Company name',
        },
        address: {
          label: 'Address',
          placeholder: 'Address',
        },
        address2: {
          label: 'Address 2',
          placeholder: 'Address 2',
        },
        city: {
          label: 'City',
          placeholder: 'City',
        },
        state: {
          label: 'State',
          placeholder: 'State',
        },
        zip: {
          label: 'Zip',
          placeholder: 'Zip',
        },
        country: {
          label: 'Country',
          placeholder: 'Country',
        },
      },
    },
    comment: {
      tags: {
        pto_rejected: 'PTO rejected',
        pto_approved: 'PTO approved',
        timesheet_rejected: 'Timesheet rejected',
        timesheet_approved: 'Timesheet approved',
      },
    },
    log: {
      actions: {
        0: 'Invitation accepted',
        1: 'Email confirmed',
        2: 'Logged in',
        3: 'Logged out',
        4: 'Time log created',
        5: 'Time log started',
        6: 'Time log stopped',
        7: 'Time log updated',
        8: 'Time log deleted',
        9: 'Timesheet submitted',
        10: 'Policy accepted',
        11: 'PTO created',
      },
    },
    profile: {
      messages: {
        updated: 'Profile information have been updated successfully.',
        created: 'Profile information have been created successfully.',
      },
      fields: {
        firstName: {
          label: 'First name',
          placeholder: 'First name',
        },
        lastName: {
          label: 'Last name',
          placeholder: 'Last name',
        },
        address: {
          label: 'Address',
          placeholder: 'Address',
        },
        address2: {
          label: 'Address 2',
          placeholder: 'Address 2',
        },
        city: {
          label: 'City',
          placeholder: 'City',
        },
        state: {
          label: 'State',
          placeholder: 'State',
        },
        zip: {
          label: 'Zip',
          placeholder: 'Zip',
        },
        phone: {
          label: 'Phone',
          placeholder: 'Phone',
        },
        ssn: {
          label: 'SSN#',
          placeholder: 'SSN#',
        },
        title: {
          label: 'Title',
          placeholder: 'Title',
        },
      },
    },
    policy: {
      fields: {
        text: {
          label: 'Policy text',
        },
      },
    },
    schedule: {
      messages: {
        created: 'Created',
        updated: 'Updated',
      },
      fields: {
        startTime: {
          label: 'Start Time',
          placeholder: 'Start time',
        },
        workLength: {
          label: 'Work Length (Hours)',
          placeholder: 'Work length',
        },
        breakLength: {
          label: 'Break Length (Minutes)',
          placeholder: 'Break length',
        },
      },
    },
    ptoAvailability: {
      fields: {
        year: {
          label: 'Year',
          placeholder: 'Year',
        },
        search: {
          placeholder: 'Search by Name',
          year: 'Search by year',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/translations/en.js